import { SiteLayout, PageBanner } from "../components/site/SiteLayout";
import { Team } from "../components/site/Sections2";
import { usePrefs } from "../context/PrefsContext";

export default function PasukanKami() {
  const { t } = usePrefs();
  return (
    <SiteLayout>
      {(content) => (
        <div data-testid="pasukan-page">
          <PageBanner title={t.nav.team} subtitle={t.banner.teamSub} image={content.page_banners?.team?.image} video={content.page_banners?.team?.video} posY={content.page_banners?.team?.pos_y} />
          <Team team={content.team} />
        </div>
      )}
    </SiteLayout>
  );
}
